/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetIndustriesCategoryResponse
} from './schema'



export const utxIndustriesGetIndustriesCategories = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetIndustriesCategoryResponse>> => {
    return axios.get(
      `/industries`,options
    );
  }


export const getUtxIndustriesGetIndustriesCategoriesQueryKey = () => [`/industries`];

    
export type UtxIndustriesGetIndustriesCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof utxIndustriesGetIndustriesCategories>>>
export type UtxIndustriesGetIndustriesCategoriesQueryError = AxiosError<unknown>

export const useUtxIndustriesGetIndustriesCategories = <TData = Awaited<ReturnType<typeof utxIndustriesGetIndustriesCategories>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxIndustriesGetIndustriesCategories>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxIndustriesGetIndustriesCategoriesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxIndustriesGetIndustriesCategories>>> = ({ signal }) => utxIndustriesGetIndustriesCategories({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxIndustriesGetIndustriesCategories>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

